export default __webpack_public_path__ + "static/media/circle-plus.0f4ea6b6.svg";